import { OPEN_AGENT_EDIT_MODE_QUERY_PARAM } from '@modules/agents/constants';
import { ConnectSlackButton } from '@modules/common/components/ConnectSlackButton';
import { NAV_PATHS } from '@modules/common/constants';
import { useGetTenantSluglessUrl } from '@modules/common/hooks';
import { OPEN_SUBSCRIBE_DRAWER_QUERY_PARAM } from '@modules/subscribe/constants';
import { Box } from '@mui/material';

interface SlackOutboundConnectButtonProps {
  onClick?: () => void;
}

export const SlackOutboundConnectButton = ({
  onClick,
}: SlackOutboundConnectButtonProps) => {
  const currentRoute = useGetTenantSluglessUrl();

  const redirectRouteOnConnect = (() => {
    if (currentRoute.includes(`/${NAV_PATHS.AGENTS}`)) {
      return `${currentRoute}?${OPEN_AGENT_EDIT_MODE_QUERY_PARAM}=true`;
    }

    return currentRoute.includes(`?${OPEN_SUBSCRIBE_DRAWER_QUERY_PARAM}`)
      ? currentRoute
      : `${currentRoute}?${OPEN_SUBSCRIBE_DRAWER_QUERY_PARAM}=true`;
  })();

  return (
    <Box>
      <ConnectSlackButton
        buttonProps={{ color: 'primary', variant: 'outlined', onClick }}
        redirectRouteOnConnect={redirectRouteOnConnect}
      >
        Connect Slack
      </ConnectSlackButton>
    </Box>
  );
};
